import LanguageManager from '../language_manager/language_manager';
import safe from '../../util/safe';
import DomUtils from '../../util/dom_utils';
import StarzplayerConstants from '../../starzplayer_constants';

const template = require('./subtitles_audio_track.hbs');

module.exports = (() => {
    let settingsElem = 'bitdash-settings';
    let settingsElemCustom = 'bitdash-settings--custom bitdash-settings-pane bitdash-settings--subaudio';
    let emitter;

    const _ = {
        initLayout(adapter, eventEmitter) {

            const subtitles = this.standardizeLang(this.uniqueEntries(adapter.getAvailableSubtitles()));
            const audioTrack = this.standardizeLang(this.uniqueEntries(adapter.getAvailableAudio()), true);
            const btnSettings = document.querySelector('.settings-custom') ? document.querySelector('.settings-custom') : this.addIcon();

            emitter = eventEmitter;

            //FIXME: 
            // var savedPreferences = Preferences.getFromLocalStorage();
            
            // emitter.emit('event', 'get-preferences-from-localstorage').then(function (preferences) {
            //     savedPreferences = preferences;
            // });
            const savedPreferences = JSON.parse(localStorage.getItem('userPreferences'));

            if(savedPreferences){
                this.activateTracksFromPreferences(adapter, savedPreferences);
            } else {
                this.activateTracksFromSettings(adapter, subtitles, audioTrack);
            }
            const activeSubtitle = adapter.getSubtitle();
            const activeAudio = adapter.getAudio();

            this.markActiveTrack(activeSubtitle, subtitles);
            this.markActiveTrack(activeAudio, audioTrack);

            btnSettings.onclick = () => {
                const domSettingsCustom = safe.code(() => document.getElementsByClassName(settingsElemCustom));
                if (domSettingsCustom.length >= 1) {
                    this.toggle(domSettingsCustom[0]);
                    this.toggleClass('.settings-custom', 'is-active');
                }
            };

            this.render(template({
                subtitlesObj: subtitles,
                audioTrackObj: audioTrack,
                audioTitle: LanguageManager.get('audio'),
                subtitlesTitle: LanguageManager.get('subtitles')
            }));
            this.events(adapter);
            return true;
        },

        clean(adapter) {
            this.setSubtitle(adapter);
            document.querySelector('.subtitles-select[for=\'sub-\']').click();
            DomUtils.destroyElementByType('class', settingsElemCustom);
        },

        toggleClass(selector, className) {
            const elem = safe.code(() => document.querySelector(selector));
            if (elem.classList.contains(className)) {
                elem.classList.remove(className);
            } else {
                elem.classList.add(className);
            }
            return elem;
        },

        addClass(selector, className) {
            const elem = safe.code(() => document.querySelector(selector));
            if (elem && !elem.classList.contains(className)) {
                elem.classList.add(className);
            }
            return elem;
        },

        removeClass(selector, className) {
            const elem = safe.code(() => document.querySelector(selector));
            if (elem && elem.classList.contains(className)) {
                elem.classList.remove(className);
            }
            return elem;
        },

        standardizeLang(items, isAudio) {
            const languages = Object.keys(StarzplayerConstants.LANG);

            return items.map(item => {
                if (!item.lang) {
                    item.lang = 'off';
                }

                if (item.lang === 'en' && !isAudio) {
                    item['display_lang'] = 'english_cc';
                } else {
                    item['display_lang'] = languages.indexOf(item.lang) > 0 ? StarzplayerConstants.LANG[item.lang] : item.lang;
                }
                item['display_lang'] = LanguageManager.get(item['display_lang']);
                return item;
            });
        },

        activateTracksFromSettings(adapter, subtitleTracks, audioTracks) {
            if (localStorage) {
                let playerConfig = localStorage.getItem('bitdash_config');
                if (playerConfig) {
                    playerConfig = JSON.parse(playerConfig);
                    let subtitleTrackFromSettings = this.findTrackByLanguage(subtitleTracks, playerConfig.subtitleLang);
                    let audioTrackFromSettings = this.findTrackByLanguage(audioTracks, playerConfig.audioLang);
                    if (subtitleTrackFromSettings) {
                        this.setSubtitle(adapter, {targetValue: subtitleTrackFromSettings.id, targetLang: playerConfig.subtitleLang});
                    }
                    if (audioTrackFromSettings) {
                        adapter.setAudio(audioTrackFromSettings.id);
                    }
                    return;
                }
                // Default to subtitles off
                this.setSubtitle(adapter, undefined);
                // Default to english audio
                let defaultAudioTrack = this.findTrackByLanguage(audioTracks, 'en');
                if (defaultAudioTrack) {
                    adapter.setAudio(defaultAudioTrack.id);
                }
            }
        },

        uniqueEntries(entries) {
            let mappedEntries = {};
            let uniqueEntries = [];

            entries.forEach((e, i) => {
                mappedEntries[e.lang] = i;
            });

            Object.keys(mappedEntries).forEach(key => {
                uniqueEntries.push(
                    entries[parseInt(mappedEntries[key])]
                );
            });

            return uniqueEntries;
        },

        markActiveTrack(activeTrack, trackList) {
            if (trackList.length === 1) {
                trackList[0].active = true;
            } else {
                let trackToMark = trackList.find(function(track) {
                    if (activeTrack.lang !== null) {
                        return track.lang === activeTrack.lang;
                    } else {
                        return track.label === activeTrack.label;
                    }
                });
                if (trackToMark) {
                    trackToMark.active = true;
                }
            }
        },

        addIcon() {
            const btn = document.createElement('button');
            const oldCaptionsBtn = document.getElementsByClassName('bitdash-captions')[0];

            btn.setAttribute('type', 'button');
            btn.setAttribute('class', 'settings-custom');
            btn.innerHTML = 'Settings';

            const toolTip = document.createElement('div');
            toolTip.classList.add('bitdash-btns');
            toolTip.classList.add('bitdash-btns-subaudio');
            toolTip.setAttribute('data-tooltip', LanguageManager.get('tooltip_audio_subtitle'));
            oldCaptionsBtn.parentNode.insertBefore(toolTip, oldCaptionsBtn);
            toolTip.appendChild(btn);
            this.hide(oldCaptionsBtn);
            return btn;
        },

        // FIXME Move this code to domUtils
        buildTag(tagName, classes, innerHTML) {
            let containerDiv = document.createElement(tagName);
            containerDiv.className = classes;
            containerDiv.innerHTML = innerHTML;
            return containerDiv;
        },

        classify(selectorName) {
            return '.' + selectorName;
        },

        render(html) {
            let containerElem = safe.code(() => document.getElementsByClassName(settingsElem)[0]);
            containerElem.parentNode.appendChild(this.buildTag('div', settingsElemCustom, html));

            return true;
        },

        setSubtitle(adapter, value = {targetValue: null}) {
            if (value.targetLang === 'ar') {
                document.querySelector('.bitdash-subs').classList.add('is-arabic');
            }
            adapter.setSubtitle(value.targetValue);
        },

        setAudioTrack(adapter, value) {
            return (value.lang && value.id) ? adapter.setAudio(value.id) : false;
        },

        select(type, args) {
            const elem = args.el;
            const targetValue = elem.getAttribute('data-val');
            const targetLang = elem.getAttribute('data-lang');
            if (elem.classList.contains('is-selected')) {
                return;
            }
            
            emitter.emit('event','preferences-update', {
                type,
                targetLang
            });


            if (type === 'subtitles') {
                if(targetValue === ""){
                    this.activateDefaultSubtitles(args.adapter);
                } else {
                    this.setSubtitle(args.adapter, {targetValue, targetLang});
                }
                const targetValueId = '#sub-'+targetValue;
                const targetLangId = document.querySelector(targetValueId).value;
                if (targetLangId === 'ar') {
                    document.querySelector('.bitdash-subs').classList.add('is-arabic');
                } else {
                    document.querySelector('.bitdash-subs').classList.remove('is-arabic');
                }
                Array.from(document.querySelectorAll('.subtitles-select')).forEach(el => el.classList.remove('is-selected'));
            } else {
                args.adapter.setAudio(targetValue);
                Array.from(document.querySelectorAll('.audiotrack-select')).forEach(el => el.classList.remove('is-selected'));
            }

            if (!elem.classList.contains('is-selected')) {
                elem.classList.add('is-selected');
            }

            return true;
        },

        show(elem) {
            elem.classList.add('is-shown');
            elem.setAttribute('data-is-visible', '1');

            if (emitter) {
                emitter.emit('menu-shown', 'subtitles-audio-selector');
            }
        },

        hide(elem) {
            if (!elem) {
                elem = elem || safe.code(() => document.getElementsByClassName(settingsElemCustom)[0]);
                this.removeClass('.settings-custom', 'is-active');

                if (!elem) {
                    return false;
                }
            }
            elem.classList.remove('is-shown');
            elem.removeAttribute('data-is-visible');
            if (emitter) {
                emitter.emit('menu-hidden', 'subtitles-audio-selector');
            }
        },

        toggle(elem) {
            if (elem.getAttribute('data-is-visible') === '1') {
                this.hide(elem);
            } else {
                this.show(elem);
            }
        },

        events(adapter) {
            return (
                Array.from(safe.code(() => document.querySelectorAll('.subtitles-select'))).map(el => {
                    el.addEventListener('click', (e) => this.select('subtitles', {'adapter': adapter, 'el': e.target}));
                }) &&
                Array.from(safe.code(() => document.querySelectorAll('.audiotrack-select'))).map(el => {
                    el.addEventListener('click', (e) => this.select('audio', {'adapter': adapter, 'el': e.target}));
                })
            );
        },

        findTrackByLanguage(trackList, language) {
            return trackList.find(track => track.lang === language);
        },

        activateTracksFromPreferences(adapter, preferences){
            // get available tracks from the player
            const subtitles = this.standardizeLang(this.uniqueEntries(adapter.getAvailableSubtitles()));
            const audioTrack = this.standardizeLang(this.uniqueEntries(adapter.getAvailableAudio()), true);

            if (preferences.playback) {
                const prefSubtitles = preferences.playback.subtitles || 'en';
                const prefAudio = preferences.playback.audio || 'en';

                let subtitleTrackFromSettings = this.findTrackByLanguage(subtitles, prefSubtitles);
                let audioTrackFromSettings = this.findTrackByLanguage(audioTrack, prefAudio);

                if (subtitleTrackFromSettings) {
                    this.setSubtitle(adapter, {
                        targetValue: subtitleTrackFromSettings.id,
                        targetLang: prefSubtitles
                    });
                } else {
                    this.activateDefaultSubtitles(adapter);
                }
                
                if (audioTrackFromSettings) {
                    this.setAudioTrack(adapter, audioTrackFromSettings);
                } else {
                    this.activateDefaultAudio(adapter);
                }
            } else {
                this.activateDefaultSubtitles(adapter);
                this.activateDefaultAudio(adapter);
            }
        },

        activateDefaultSubtitles(adapter){
            this.setSubtitle(adapter, undefined);
        },

        activateDefaultAudio(adapter){
            //get available tracks from the player
            const audioTrack = this.standardizeLang(this.uniqueEntries(adapter.getAvailableAudio()), true);
            // Default to english audio
            let defaultAudioTrack = this.findTrackByLanguage(audioTrack, 'en');
            if (defaultAudioTrack) {
                adapter.setAudio(defaultAudioTrack.id);
            }
        }
    };

    return _;
})();



// WEBPACK FOOTER //
// ./src/modules/subtitles_audio_track/subtitles_audio_track.js